import React from 'react'

const ClearIcon = () => {
    return (
        <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.66362 3.13304C2.51627 1.79217 4.10518 0.890625 5.92453 0.890625C8.64427 0.890625 10.8491 2.90534 10.8491 5.39062C10.8491 7.8759 8.64427 9.89062 5.92453 9.89062C3.20479 9.89062 1 7.8759 1 5.39062" stroke="#525252" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4.07812 3.14062H1.61586V0.890625" stroke="#525252" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export default ClearIcon
